// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-container img[data-v-bf6ac2e8]{margin:auto;display:block;height:70px;width:70px}", ""]);
// Exports
module.exports = exports;
